import { apiClient, unwrap } from '@services/api';
import type { Review } from '@/types';

export type WholesalerReview = Review & {
  restaurantName?: string;
  avgRating?: number;
};

export const reviewService = {
  async submit(data: {
    orderId: string;
    ratingSpeed: number;
    ratingQuality: number;
    ratingFlavor: number;
    comment?: string;
  }): Promise<Review> {
    const res = await apiClient.post<Review>('/review/submit', data);
    return unwrap(res);
  },

  async getWholesalerReviews(): Promise<WholesalerReview[]> {
    const res = await apiClient.get<WholesalerReview[]>('/review/wholesaler');
    return unwrap(res);
  },
};
